<template>
    <div @mouseup="stopSelecting()" style="width: auto">
        <div class="modal-content">
            <div class="centered_div">
                <div class="header_company_name">
                    <span class="company_alias">{{ company_alias }}</span><span class="company_rut">{{ company_rut
                        }}</span>
                </div>
                <div class="per_counterpart_reminder">
                    A nivel de contraparte, estos documentos quedaran clasificados por defecto como:
                    <table class="per_counterpart_table">
                        <tr>
                            <td class="ttitle_class td_doc_type_parent" rowspan="2">
                                <div class="parent_document_type">
                                    Documentos <span class="doc_type_title">{{ tipo_documentos }}</span>
                                </div>
                            </td>
                            <td class="ttitle_class td_classification_account">
                                <div class="tttitle">Clasificación Cuenta</div>
                            </td>
                            <td class="ttitle_class td_classification_account" v-for="type in types" v-bind:key="type">
                                <div class="attribute_title">
                                    {{ type }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="parent_data_container">
                                <div>
                                    <div v-for="plan in parent_entry.accounts" v-bind:key="plan['level_3']"
                                        class="clasificado">
                                        <span
                                            :class="['attribute', { template_attribute: plan['pure_template'] == 'true' }]">
                                            {{ plan["level_3"] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="parent_data_container"
                                    v-if="(!parent_entry.accounts || !parent_entry.accounts.length) && !parent_entry.cancelled">
                                    <div class="sin_clasificar">
                                        Sin Clasificar
                                    </div>
                                </div>
                            </td>
                            <td class="fila class_container" v-for="type in types" v-bind:key="type">
                                <div v-if="parent_entry['attributable']">
                                    <div class="parent_data_container" v-for="subtype in parent_entry.attribute[type]"
                                        v-bind:key="subtype['name']">
                                        <div class="clasificado">
                                            <span
                                                :class="['attribute', { template_attribute: subtype['pure_template'] == 'true' }]">
                                                {{ subtype["name"] }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="parent_data_container"
                                        v-if="(!parent_entry.attribute[type] || !parent_entry.attribute[type].length) && !parent_entry.cancelled">
                                        <div class="sin_clasificar">
                                            Sin Clasificar
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!parent_entry['attributable']" class="parent_data_container">
                                    <div class="na_background"
                                        title="No se puede asignar esta categoria sin asignar una Cuenta de Venta o de Costo primero.">
                                        N / A</div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="header_subtitle">Para cada documento de tus obligaciones, puedes asignar las cuentas y las
                    categorias correspondientes.
                </div>
                <div class="container_table table-container">
                    <div class="centered_div help_classificator">
                        (Puedes arrastrar el mouse para elegir varios documentos a la vez y
                        clasificar esos documentos al mismo tiempo).
                    </div>
                    <table class="big_table">
                        <tr>
                            <td class="select_all_button_td" rowspan="2">
                                <SimpleButton :buttonStyle="`linear-gradient(45deg, #034c62, #044172)`"
                                    @click="selectAll()" class="todos">
                                    <span v-if="allSelected">Ninguno</span>
                                    <span v-else>Todos</span>
                                </SimpleButton>
                            </td>
                            <td class="ttitle">
                                <div class="tttitle">Fecha Emisión</div>
                            </td>
                            <td class="ttitle">
                                <div class="tttitle">Tipo Documento</div>
                            </td>
                            <td class="ttitle">
                                <div class="tttitle">Nro Documento</div>
                            </td>
                            <td class="ttitle">
                                <div class="tttitle">Monto</div>
                            </td>
                            <td class="ttitle_class">
                                <div class="tttitle">Clasificación Cuenta</div>
                            </td>
                            <td class="ttitle_class" v-for="type in types" v-bind:key="type">
                                <div class="attribute_title">
                                    {{ type }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="ttitle2">
                                <div class="tttitle sort_button_container">
                                    <SortButton @click="changeOrderGeneric('emitted_at')" :globalSortColumn="sortColumn"
                                        :column="'emitted_at'" :sortDirection="sortDirection" />
                                </div>
                            </td>
                            <td class="ttitle2">
                                <div class="tttitle sort_button_container">
                                    <SortButton @click="changeOrderGeneric('doc_type')" :globalSortColumn="sortColumn"
                                        :column="'doc_type'" :sortDirection="sortDirection" />
                                </div>
                            </td>
                            <td class="ttitle2">
                                <div class="tttitle sort_button_container">
                                    <SortButton @click="changeOrderGeneric('doc_number')" :globalSortColumn="sortColumn"
                                        :column="'doc_number'" :sortDirection="sortDirection" />
                                </div>
                            </td>
                            <td class="ttitle2">
                                <div class="tttitle sort_button_container">
                                    <SortButton @click="changeOrderGeneric('amount')" :globalSortColumn="sortColumn"
                                        :column="'amount'" :sortDirection="sortDirection" />
                                </div>
                            </td>
                            <td class="ttitle2">
                                <div class="tttitle sort_button_container">
                                    <SortButton @click="changeOrderGeneric('accounts')" :globalSortColumn="sortColumn"
                                        :column="'accounts'" :sortDirection="sortDirection" />
                                </div>
                            </td>
                            <td class="ttitle2" v-for="type in types" v-bind:key="type">
                                <div class="attribute_title sort_button_container">
                                    <SortButton @click="changeOrderGeneric('attribute', type)"
                                        :globalSortColumn="sortColumn" :column="'attribute_' + type"
                                        :sortDirection="sortDirection" />
                                </div>
                            </td>
                        </tr>
                        <tr v-for="entry in entries" v-bind:key="entry.id" @mouseenter="selectIfSelecting(entry.order)"
                            @mouseleave="selectIfFirstSelected(entry.order)"
                            :class="['counterpart_row', { cancelled: entry.cancelled }]">
                            <td :class="['fila', 'first_button_td']" @mouseenter="hover($event)"
                                @mouseleave="leave($event)" @mousedown="selectThis($event, entry.cancelled)">
                                <button v-if="!entry.cancelled" @click="selectRow(entry.order)" :class="[
                                    'first_button',
                                    { unselected_button: !entry.selected },
                                    { selected_button: entry.selected },
                                ]">
                                    {{ entry.selected ? "✔" : "" }}
                                </button>
                                <span v-else class="anulado">Anulado</span>
                            </td>
                            <td :class="['fila', 'doc_date', { first_row: entry.index == 0 }]"
                                @mouseenter="hover($event)" @mouseleave="leave($event)"
                                @mousedown="selectThis($event, entry.cancelled)">
                                {{ entry.emitted_at }}
                            </td>
                            <td class="fila doc_type" @mousedown="selectThis($event, entry.cancelled)"
                                @mouseenter="hover($event)" @mouseleave="leave($event)">
                                {{ entry.doc_type }}
                            </td>
                            <td class="fila doc_number" @mousedown="selectThis($event, entry.cancelled)"
                                @mouseenter="hover($event)" @mouseleave="leave($event)">
                                {{ entry.doc_number }}
                            </td>
                            <td class="fila doc_amount nobreak" @mousedown="selectThis($event, entry.cancelled)"
                                @mouseenter="hover($event)" @mouseleave="leave($event)">
                                {{ money(entry.amount) }}
                            </td>
                            <td class="fila class_container" @mousedown="selectThis($event, entry.cancelled)"
                                @mouseenter="hover($event)" @mouseleave="leave($event)">
                                <div class="button_container">
                                    <SimpleButton v-for="plan in entry.accounts" v-bind:key="plan['level_3']"
                                        @click="() => openAccountByCompanyModal('Cuentas de la compañía', entry, 'is-account')"
                                        :classiValue="plan['level_3']">
                                        <span
                                            :class="['attribute', { template_attribute: plan['pure_template'] == 'true' }]">
                                            {{ plan["level_3"] }}
                                        </span>
                                    </SimpleButton>
                                </div>
                                <div class="button_container"
                                    v-if="(!entry.accounts || !entry.accounts.length) && !entry.cancelled">
                                    <SimpleButton :clasificar="true"
                                        @click="() => openAccountByCompanyModal('Cuentas de la compañía', entry, 'is-account')">
                                        Clasificar
                                    </SimpleButton>
                                </div>
                            </td>
                            <td class="fila class_container" @mousedown="selectThis($event)" @mouseenter="hover($event)"
                                @mouseleave="leave($event)" v-for="type in types" v-bind:key="type">
                                <div v-if="entry['attributable']">
                                    <div class="button_container" v-for="subtype in entry.attribute[type]"
                                        v-bind:key="subtype['name']">
                                        <SimpleButton
                                            @click="() => openAccountByCompanyModal('Categorías de la compañía', entry, 'is-category', type)"
                                            :classiValue="subtype['name']">
                                            <span
                                                :class="['attribute', { template_attribute: subtype['pure_template'] == 'true' }]">
                                                {{ subtype["name"] }}
                                            </span>
                                        </SimpleButton>
                                    </div>
                                    <div class="button_container"
                                        v-if="(!entry.attribute[type] || !entry.attribute[type].length) && !entry.cancelled">
                                        <SimpleButton :clasificar="true"
                                            @click="() => openAccountByCompanyModal('Categorías de la compañía', entry, 'is-category', type)">
                                            Clasificar
                                        </SimpleButton>
                                    </div>
                                </div>
                                <div v-if="!entry['attributable']">
                                    <SimpleButton @click="na_warning()" class="na_button"
                                        title="No se puede asignar esta categoria sin asignar una Cuenta de Venta o de Costo primero.">
                                        N / A</SimpleButton>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
        </footer>
        <button class="modal-close" @click="close"></button>
    </div>
</template>

<script>
import { getDocumentsInvolved, getSpecificCounterparts } from "@/api/carteraAnalista";
import ClassifyAccountAttributes from "@/components/modals/ClassifyAccountAttributes";
import SimpleButton from "@/components/modals/SimpleButton";
import { parseToMoney } from "@/utils/currency";
import { consoleHandlerError, notificate } from "@/utils/message";
import SortButton from "../components/modals/SortButton.vue";

let count = 0;
const order = ['Ventas', 'Costos', 'Gastos', 'No Operacional', 'Activo'];
const MAX_LIST_BEFORE_FULL_RELOAD = 30;

export default {
    name: "DashboardClassificatorXDocument",
    components: {
        SimpleButton,
        SortButton,
    },
    props: {
        parent_entry: Object,
        types: Array,
        company_involved: Number,
        document_type: String,
        company_alias: String,
        company_rut: String,
    },
    data() {
        return {
            sortColumn: 'order',
            sortDirection: 'asc',
            entries: [],
            allSelected: false,
            selecting: false,
            firstSelection: true,
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal"
            },
            buttonStyles: ['b-red', 'b-blue', 'b-yellow', 'b-green', 'b-brown', 'b-orange', 'b-pink'],
        };
    },
    methods: {
        findLowestLevel1(list) {
            let min = list.length + 1;
            for (const elem of list) {
                const val = elem['level_1'];
                const io = order.indexOf(val);
                if (io >= 0 && io < min) {
                    min = io;
                }
                if (min == 0) {
                    break;
                }
            }
            return min;
        },
        changeColumn(column, subtype = null) {
            let column_name = column;
            if (subtype) {
                column_name = column + '_' + subtype;
            }
            if (this.sortColumn != column_name) {
                count = 0;
                this.sortColumn = column;
                if (subtype) {
                    this.sortColumn = column + '_' + subtype;
                }
            }
            count = (count + 1) % 3;
        },
        sortData(column, subtype = null, reset_msg = true) {
            if (reset_msg) {
                this.resetMsgs();
            }
            let col_name = column;
            if (subtype != null) {
                col_name = 'attribute_' + subtype;
            }
            if (count == 0) {
                this.sortColumn = 'order';
                this.sortDirection = 'asc';
            } else if (count == 1) {
                this.sortColumn = col_name;
                this.sortDirection = 'asc';
            } else if (count == 2) {
                this.sortColumn = col_name;
                this.sortDirection = 'desc';
            }
        },
        actualSort(column, subtype = null) {
            this.entries = this.entries.sort((a, b) => {
                let pos = this.sortColumn.indexOf('attribute_');
                let col_name = this.sortColumn;
                if (pos == 0) {
                    col_name = 'attribute';
                }
                const valA = a[col_name];
                const valB = b[col_name];
                if (col_name == 'accounts') {
                    const la = valA.length;
                    const lb = valB.length;
                    if (la == 0 || lb == 0) {
                        return this.sortDirection === 'asc' ? la - lb : lb - la;
                    }
                    const lowestA = this.findLowestLevel1(valA);
                    const lowestB = this.findLowestLevel1(valB);
                    if (lowestA == lowestB) {
                        const subOrderA = a['amount'];
                        const subOrderB = b['amount'];
                        return subOrderB - subOrderA;
                    }
                    return this.sortDirection === 'asc' ? lowestA - lowestB : lowestB - lowestA;
                } else if (col_name == 'attribute') {
                    const attA = a['attributable'];
                    const attB = b['attributable'];
                    if (!attA || !attB) {
                        return this.sortDirection === 'asc' ? attA - attB : attB - attA;
                    }
                    const la = subtype in valA ? valA[subtype].length : 0;
                    const lb = subtype in valB ? valB[subtype].length : 0;
                    if (la == 0 || lb == 0) {
                        return this.sortDirection === 'asc' ? la - lb : lb - la;
                    }
                    let totalA = '', totalB = '';
                    for (let index = 0; index < valA[subtype].length; index++) {
                        totalA += valA[subtype]['name'];
                    }
                    for (let index = 0; index < valB[subtype].length; index++) {
                        totalB += valB[subtype]['name'];
                    }
                    if (totalA == totalB) {
                        const subOrderA = a['amount'];
                        const subOrderB = b['amount'];
                        return subOrderB - subOrderA;
                    }
                    const total_diff = totalA.localeCompare(totalB);
                    return this.sortDirection === 'asc' ? total_diff : -total_diff;
                } else {
                    let compare = 0;
                    if ((typeof valA === 'boolean' && typeof valB === 'boolean') || (typeof valA === 'number' && typeof valB === 'number')) {
                        compare = valA - valB;
                    } else {
                        compare = valA.localeCompare(valB);
                    }
                    if (compare == 0) {
                        const subOrderA = a['amount'];
                        const subOrderB = b['amount'];
                        return subOrderB - subOrderA;
                    }
                    return this.sortDirection === 'asc' ? compare : -compare;
                }
            });
        },
        changeOrderGeneric(column, subtype = null) {
            this.changeColumn(column, subtype);
            this.sortData(column, subtype, false);
            this.actualSort(column, subtype);
        },
        na_warning() {
            notificate('No se puede asignar esta categoria sin asignar una Cuenta de Venta o de Costo primero.');
        },
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        getButtonStyle(name) {
            const asciiSum = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
            const styleIndex = asciiSum % this.buttonStyles.length;
            return this.buttonStyles[styleIndex];
        },
        hover(event) {
            event.target.classList.add("hovering");
        },
        leave(event) {
            event.target.classList.remove("hovering");
        },
        selectRow(row) {
            this.toggle(row);
        },
        selectIfFirstSelected(row) {
            if (this.selecting && this.firstSelection) {
                this.toggle(row);
                this.firstSelection = false;
            }
        },
        selectIfSelecting(row) {
            if (this.selecting) {
                this.toggle(row);
            }
        },
        selectThis(event, cancelledP) {
            if (cancelledP) {
                return;
            }
            this.selecting = true;
        },
        stopSelecting() {
            this.selecting = false;
            this.firstSelection = true;
        },
        close() {
            this.$emit("close");
        },
        toggle(index) {
            const oldEntries = [...this.entries];
            for (let i = 0; i < oldEntries.length; i++) {
                if (oldEntries[i]['order'] == index) {
                    oldEntries[i]["selected"] = !this.entries[i]["selected"];
                }
            }
            this.entries = oldEntries;

            let areAllSelected = true;
            for (const elem of oldEntries) {
                if (!elem["selected"]) {
                    areAllSelected = false;
                }
            }
            this.allSelected = areAllSelected;
        },
        isRowSelected(row) {
            return row["selected"];
        },
        selectAll() {
            const oldEntries = [...this.entries];
            this.allSelected = !this.allSelected;
            for (const elem of oldEntries) {
                if (elem["cancelled"]) {
                    continue;
                }
                elem["selected"] = this.allSelected;
            }
            this.entries = oldEntries;
        },
        getAllSelectedDocumentsId() {
            const oldEntries = [...this.entries];
            let selectedIds = [];
            for (const elem of oldEntries) {
                if (elem["selected"]) {
                    selectedIds.push(elem.td_id);
                }
            }
            return selectedIds;
        },
        reloadSpecificRows(ci_id, list_ids, document_type) {
            if (list_ids.length > MAX_LIST_BEFORE_FULL_RELOAD) {
                this.initDocsInvolved();
                return;
            }
            getSpecificCounterparts(ci_id, list_ids, document_type).then((result) => {
                const specific_counterparts = result.data['specific_counterparts'];
                let indexes = [];
                for (const elem of specific_counterparts) { //quadratic but whatevs
                    for (let ii = 0; ii < this.entries.length; ii++) {
                        const entry = this.entries[ii];
                        if (elem['td_id'] == entry['td_id']) {
                            elem['selected'] = false;
                            elem['order'] = ii;
                            elem['index'] = ii;
                            indexes.push({ index: ii, entry: elem });
                        }
                    }
                }
                for (const elem of indexes) {
                    this.entries.splice(elem.index, 1, elem.entry)
                }
            });
        },
        openAccountByCompanyModal(tittleModal, entry, type, categoryType = null) {
            if (!this.isRowSelected(entry)) {
                this.selectRow(entry.index);
            }
            const documentsIds = this.getAllSelectedDocumentsId();
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ClassifyAccountAttributes,
                width: "90%",
                canCancel: ["escape", "button", "outside"],
                props: {
                    tittleModal: tittleModal,
                    contraparteId: this.company_involved,
                    type,
                    categoryType,
                    documentsIds,
                    documentIdSelected: entry.td_id,
                    document_type: this.document_type,
                },
                events: {
                    close: (reloadedData) => {
                        if (documentsIds.length > MAX_LIST_BEFORE_FULL_RELOAD) {
                            this.initDocsInvolved();
                            return;
                        }
                        let indexes = [];
                        for (const elem of reloadedData) { //quadratic but whatevs
                            for (let ii = 0; ii < this.entries.length; ii++) {
                                const entry = this.entries[ii];
                                if (elem['td_id'] == entry['td_id']) {
                                    elem['selected'] = false;
                                    elem['order'] = ii;
                                    elem['index'] = ii;
                                    indexes.push({ index: ii, entry: elem });
                                }
                            }
                        }
                        for (const elem of indexes) {
                            this.entries.splice(elem.index, 1, elem.entry)
                        }
                    }
                },
            });
        },
        initDocsInvolved() {
            this.allSelected = false;
            getDocumentsInvolved(this.company_involved, this.document_type)
                .then((response) => {
                    this.entries = response.data["data"];
                    let index = 0;
                    for (const elem of this.entries) {
                        elem["selected"] = false;
                        elem["index"] = index;
                        elem["order"] = index;
                        index++;
                    }
                })
                .catch((error) => {
                    consoleHandlerError({ error });
                });
        },
    },
    mounted() {
        this.initDocsInvolved();
    },
    computed: {
        tipo_documentos: function () { return this.document_type == 'P' ? 'Por Pagar' : 'Por Cobrar' },
    },
};
</script>
<style scoped>
.header_company_name {
    text-align: center;
    width: 100%;
}

.ttitle2 {
    text-align: center;
}

.para {
    margin-left: 2em;
    margin-right: 2em;
    font-size: 70%;
}

.company_rut {
    margin-left: 0.5em;
    font-weight: 600;
    font-size: 120%;
}

.company_alias {
    font-size: 120%;
    font-weight: 900;
}

.doc_type_title {
    margin-left: 10px;
    font-size: 120%;
    font-weight: 900;
}

.header_title {
    font-size: 110%;
    font-weight: 600;
}

.header_subtitle {
    font-size: 80%;
    font-weight: 600;

}

.big_table {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
}

.ttitle_class {
    text-align: center;
    vertical-align: middle;
    padding: 10px;
}

.ttitle {
    text-align: center;
    vertical-align: middle;
    padding: 10px;
}

.tttitle {
    text-align: center;
    display: inline-block;
    width: min-content;
    font-weight: 900;
}

.sort_button_container {
    margin-bottom: 4px;
}

.attribute_title {
    font-weight: 900;
    text-transform: capitalize;
}

.hovering {
    background-color: #ffff220f;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
}

.counterpart_row {
    border-top: 1px solid #111111;
    border-bottom: 1px solid #111111;
    border-left: 1px solid #ffffff00;
    border-right: 1px solid #ffffff00;
}

.first_button {
    width: 40px;
    height: 40px;
    margin: 3px;
    transition: background-color 0.15s ease, border 0.15s ease;
}

.unselected_button {
    background-color: #f1f1f1;
    border: 2px inset #dddddd;
}

.selected_button {
    border-radius: 4px;
    color: #ffffff;
    font-weight: bold;
    background-color: #3333ff;
    border: 4px outset #dddddd;
}

.first_button_td {
    width: 120px;
    text-align: center;
}

.help_classificator {
    font-size: 80%;
    margin-bottom: 10px;
}

tr.cancelled {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEElEQVQIHQEFAPr/AJeXl/8GUwLFnMFtUgAAAABJRU5ErkJggg==");
    background-repeat: repeat-x;
    background-position: 50% 50%;
}

.anulado {
    font-size: 80%;
    color: #666;
}

.select_all_button_td {
    vertical-align: middle;
    text-align: center;
}

.select_all_button {
    width: 5.3em;
}

.todos {
    color: white;
    font-weight: 600;
    border-radius: 3px;
}

.class_container {
    text-align: center;
    vertical-align: middle;
}

.button_container {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    max-width: 400px;
    gap: 2px 4px;
    margin: 0 15px 0 15px;
}

.fila {
    padding: 5px 0 5px 0;
    text-align: center;
    vertical-align: middle;
}

.doc_type {
    font-size: 80%;
}

.doc_date {
    font-size: 90%;
}

.nobreak {
    white-space: nowrap;
}

.na_button {
    color: #777;
}

.parent_document_type {
    text-align: left;
}

.per_counterpart_reminder {
    width: 100%;
}

.per_counterpart_table {
    margin-left: auto;
    width: 100%
}

.td_doc_type_parent {
    width: 40%;
}

.clasificado {
    color: black;
    background-color: #eeeeee;
    border-radius: 8px;
    flex: 0 1 auto;
    white-space: nowrap;
    font-weight: 100 !important;
    padding: 1px 4px 1px 4px !important;
    max-width: 200px !important;
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 90%;
    margin-bottom: 4px;
}

.na_background {
    color: #333333;
    background-color: #eeeeee;
    border-radius: 8px;
    flex: 0 1 auto;
    white-space: nowrap;
    font-weight: 100 !important;
    width: 60px !important;
    padding: 1px 4px 1px 4px !important;
    overflow: hidden;
    font-size: 80% !important;
}

.sin_clasificar {
    color: #111111;
    background-color: #eeeeee;
    border-radius: 8px;
    flex: 0 1 auto;
    white-space: nowrap;
    font-weight: 100 !important;
    width: 90px !important;
    padding: 1px 4px 1px 4px !important;
    overflow: hidden;
    font-size: 80% !important;
}

.parent_data_container {
    text-align: center;
}
</style>
